<script>
	import { try_to_format_anything_as_dollars } from 'shared/format_currency'
	import Message from './Message.svelte'

	export let subtotal
	export let shipping_price
	export let coupons_enabled
	export let coupons
	export let coupon_total
	export let giftcards
	export let giftcard_payment
	export let tax_total
	export let total
	export let coupon_message
	export let giftcard_message

	export let api

	let adding_coupon
	let coupon_code = ``
	let adding_giftcard
	let giftcard_code = ``

	function enter_coupon() {
		adding_coupon = true
	}

	function add_coupon(e) {
		e.preventDefault()
		api(`/coupon/add`, { coupon_code })
			.then(() => {
				if (coupon_message && coupon_message.type === `success`) {
					adding_coupon = false
					coupon_code = ``
				}
			})
	}

	function remove_coupon(coupon_code) {
		api(`/coupon/remove`, { coupon_code })
	}

	function enter_giftcard() {
		adding_giftcard = true
	}

	function add_giftcard(e) {
		e.preventDefault()
		api(`/giftcard/add`, { giftcard_code })
			.then(() => {
				if (giftcard_message && giftcard_message.type === `success`) {
					adding_giftcard = false
					giftcard_code = ``
				}
			})
	}

	function remove_giftcard(giftcard_code) {
		api(`/giftcard/remove`, { giftcard_code })
	}
</script>


<table>
	<tbody>
		<tr class="subtotal"><td>Subtotal</td><td>{ try_to_format_anything_as_dollars(subtotal) }</td></tr>
		{#if shipping_price}<tr><td>Shipping</td><td>{ try_to_format_anything_as_dollars(shipping_price) }</td></tr>{/if}

		{#if coupon_message}
			<tr><td colspan="2"><Message bind:message={coupon_message} timeout_ms=5000 /></td></tr>
		{/if}

		{#if coupons_enabled}
			<tr class="coupons">
				<td>Coupons</td>

				<td>
					{#if coupons.length}
						-{ try_to_format_anything_as_dollars(coupon_total) }
						<div>
							{#each coupons as coupon}
								<div class="coupon">
									<span class="code">{ coupon.code }</span>
									<span class="value">{ try_to_format_anything_as_dollars(coupon.amount) }</span>
									<button type="button" class="subtle" on:click="{() => remove_coupon(coupon.code)}">Remove</button>
								</div>
							{/each}
						</div>
					{/if}

					{#if adding_coupon}
						<form on:submit="{add_coupon}">
							<input type="text" bind:value="{coupon_code}" autofocus />
						<button type="submit" class="subtle">Add</button>
						</form>
					{:else}
						<button class="subtle" on:click="{enter_coupon}">Add Coupon</button>
					{/if}
				</td>
			</tr>
		{/if}

		<tr>
			<td>Tax</td>
			<td>
				{#if tax_total > 0}
					{ try_to_format_anything_as_dollars(tax_total) }
				{:else}
					Calculated at checkout
				{/if}
			</td>
		</tr>

		{#if giftcard_message}
			<tr><td colspan="2"><Message bind:message={giftcard_message} timeout_ms=5000 /></td></tr>
		{/if}

		<tr class="giftcards">
			<td>Gift Card Payment</td>

			<td>
				{#if giftcards.length}
					-{ try_to_format_anything_as_dollars(giftcard_payment) }
					<div>
						{#each giftcards as giftcard}
							<div class="giftcard">
								<span class="code">{ giftcard.code }</span>
								<span class="value">{ try_to_format_anything_as_dollars(giftcard.value) }</span>
								<button type="button" class="subtle" on:click="{() => remove_giftcard(giftcard.code)}">Remove</button>
							</div>
						{/each}
					</div>
				{/if}

				{#if adding_giftcard}
					<form on:submit="{add_giftcard}">
						<input type="text" bind:value="{giftcard_code}" autofocus />
						<button type="submit" class="subtle">Add</button>
					</form>
				{:else}
					<button class="subtle" on:click="{enter_giftcard}">Add Gift Card</button>
				{/if}
			</td>
		</tr>

		<tr class="total"><td>Total</td><td>{ try_to_format_anything_as_dollars(total) }</td></tr>
	</tbody>
</table>


<style>

button {
	background-color: #CEFF51;
	border: 0;
	/*color: #0B0C07;*/
	color: #000;
	cursor: pointer;
	font-size: 12px;
	font-weight: 500;
	margin: 0;
	padding: 15px 30px;
	margin-top: 10px;
	text-transform: uppercase;
	border-radius: 3px;
	-webkit-font-smoothing: antialiased;
	-webkit-appearance: none;
	appearance: none;
	text-decoration: none;
}

button.subtle {
	background-color: #333;
	color: #ccc;
	margin: 5px;
}

button.subtle,
input[type="text"] {
	margin: 0;
	padding: 4px 10px;
	line-height: 20px;
	border: 1px solid #333;
}
button:focus-visible,
input:focus-visible{
	outline: 3px solid #fff;
}

table {
	border-collapse: separate;
	border-spacing: 0;
	font-weight: 400;
	font-size: 100%;
}

.giftcard,
.coupon {
	line-height: 1.2;
}

.giftcard .code,
.giftcard .value,
.coupon .code,
.coupon .value {
	font-size: 80%;
}

.giftcard .code,
.coupon .code {
	color: #999;
	margin-right: 5px;
}

.giftcard .value,
.coupon .value {
	color: #fff;
	margin-right: 5px;
}

table {
	width: 100%;
	font-size: 16px;
	color: #fff;
}

table td:first-child {
	font-size: 90%;
	font-weight: 500;
	color: #999;
}

table td {
	border-bottom: 1px solid rgba(255, 255, 255, .13333);
	padding: 5px;
	font-size: 100%;
}

table .total td {
	border-top: 1px solid #fff;
}

table tr:last-child td {
	border-bottom: none;
}
</style>
